import React from "react";
import { HStack, Radio, RadioGroup } from "@chakra-ui/react";
import type { Mode } from "../../utils/formField";

type NullableSwitchProps = {
  nullable: boolean;
  mode: Mode;
  setMode: (m: Mode) => void;
  readOnly: boolean;
  children: React.ReactNode;
};

export const NullableSwitch: React.FC<NullableSwitchProps> = ({
  nullable,
  mode,
  setMode,
  readOnly,
  children,
}) => {
  if (!nullable) {
    return <>{children}</>;
  }

  return (
    <RadioGroup
      value={mode}
      onChange={(next) => {
        if (readOnly) return;
        setMode(next === "na" ? "na" : "val");
      }}
      isDisabled={readOnly}
    >
      <HStack mb={2}>
        <Radio value="na">TBD</Radio>
      </HStack>

      <HStack align="start" spacing={2}>
        <Radio value="val" aria-label="Provide values" mt="6px" />
        {children}
      </HStack>
    </RadioGroup>
  );
};
